import React, {CSSProperties, useState} from 'react';
import {theme} from '../constants';

interface ButtonProps {
  title: string;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  colorScheme?: 'transparent' | 'dark';
  href?: string;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  style,
  colorScheme = 'dark',
  containerStyle,
  href,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const hoverStyle: CSSProperties = isHovered
    ? {
        opacity: 0.8, // Пример изменения стиля при наведении
      }
    : {};

  return (
    <div style={{...containerStyle}}>
      <a
        href={href}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          border: 'none',
          backgroundColor:
            colorScheme === 'dark' ? theme.colors.mainColor : '#FFD9C3',
          color:
            colorScheme === 'dark'
              ? theme.colors.white
              : theme.colors.mainColor,
          textAlign: 'center',
          textDecoration: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 14,
          cursor: 'pointer',
          margin: 0,
          transition: 'opacity 0.3s ease',
          borderRadius: 10,
          textTransform: 'capitalize',
          padding: '14px 40px',
          ...style,
          ...theme.fonts.SourceSansPro_600SemiBold,
          ...hoverStyle, // Применяем стиль при наведении
        }}
      >
        {title}
      </a>
    </div>
  );
};
